import Header from "../../../components/header/Header";
import HomeContainer from "../container/HomeContainer/HomeContainer";

const HomePage = () => {
  return (
    <>
      <Header title="Home" />
      <HomeContainer />
    </>
  )
}

export default HomePage
